import { getSortedAggregateSections } from '~/utils/store/aggregatePage'
import { resolveProductModelNo, resolveProductName } from '~/utils/tracking/helpers'

export const MEGA_MENU_VISIBLE_CARD_COUNT = 6
export const MEGA_MENU_PRODUCT_SLOT_COUNT = MEGA_MENU_VISIBLE_CARD_COUNT - 1
export const MEGA_MENU_QUERY_PRODUCT_COUNT = 10

/**
 * @description C 端聚合页导航浮窗通用查询参数
 * @param {Record<string, unknown>} [extra]
 * @returns {Record<string, unknown>}
 */
/**
 * 爆款精品导航浮窗锚点分类 ID（虚拟占位，非真实品类主键，与 TDC 契约 990001 对齐）
 * @see packages/contracts STORE_HOT_PRODUCTS_MEGA_MENU_ANCHOR_CATEGORY_ID
 */
export const HOT_PRODUCTS_MEGA_MENU_ANCHOR_CATEGORY_ID = '990001'

/** @deprecated 使用 HOT_PRODUCTS_MEGA_MENU_ANCHOR_CATEGORY_ID */
export const HOT_PRODUCTS_MEGA_MENU_CATEGORY_ID = HOT_PRODUCTS_MEGA_MENU_ANCHOR_CATEGORY_ID

export function buildAggregateMegaMenuQuery(extra = {}) {
  return {
    salesOrganization: 'TDC',
    view: 'MEGA_MENU',
    productLimit: MEGA_MENU_QUERY_PRODUCT_COUNT,
    includeDynamicSections: true,
    ...extra,
  }
}

export function buildHotProductsMegaMenuQuery(extra = {}) {
  return buildAggregateMegaMenuQuery({
    ...extra,
  })
}

/**
 * @description 归一化聚合页商品为导航浮窗卡片结构
 * @param {Object|null|undefined} product
 * @returns {Object|null}
 */
export function normalizeAggregateMegaMenuProduct(product) {
  if (!product || typeof product !== 'object') return null
  const prodId = product.prodId || product.id
  if (!prodId) return null
  return {
    ...product,
    id: prodId,
    prodId,
    modelNo: resolveProductModelNo(product),
    prodName: resolveProductName(product) || product.prodName || '',
    brief: product.brief || '',
    pic: product.pic || '',
    marketingMedia: product.mediaUrl || '',
    mediaType: product.mediaType || '',
    tags: Array.isArray(product.tags) ? product.tags : [],
    actTags: Array.isArray(product.actTags) ? product.actTags : [],
    price: product.price ?? null,
  }
}

/**
 * @description 将聚合页 sections 转为导航浮窗结构
 * @param {Object|null|undefined} page
 * @param {Object} [options]
 * @param {string} [options.menuKey]
 * @param {string} [options.fallbackTitle]
 * @param {(section: Object) => string|Object|null} [options.resolveAllRoute]
 * @returns {{ key: string, anchors: Array, sections: Array, fromAggregate: true }|null}
 */
export function buildMegaMenuFromAggregatePage(page, options = {}) {
  if (!page || typeof page !== 'object') return null

  const { menuKey = 'store', fallbackTitle = '', resolveAllRoute = () => null } = options

  const sections = getSortedAggregateSections(page)
    .map((section, index) => {
      const products = Array.isArray(section?.products)
        ? section.products.map(normalizeAggregateMegaMenuProduct).filter(Boolean)
        : []
      if (products.length === 0) return null

      const hasMore = products.length > MEGA_MENU_VISIBLE_CARD_COUNT
      const visibleProducts = products.slice(
        0,
        hasMore ? MEGA_MENU_PRODUCT_SLOT_COUNT : MEGA_MENU_VISIBLE_CARD_COUNT
      )
      const title = section.name || section.categoryName || fallbackTitle || page.pageName || ''

      return {
        key: `aggregate-${menuKey}-${section.id || index}`,
        title,
        categoryId: section.categoryId || null,
        productIds: visibleProducts.map((product) => product.prodId),
        products: visibleProducts,
        hasMore,
        allRoute: resolveAllRoute(section) || null,
      }
    })
    .filter(Boolean)

  if (sections.length === 0) return null

  return {
    key: menuKey,
    fromAggregate: true,
    anchors: sections.map((section) => ({ key: section.key, label: section.title })),
    sections,
  }
}
